import className from 'classnames';
import PropTypes from 'prop-types';
import React, { Component, Children } from 'react';
// import ReactDOM from 'react-dom';
// import {flattenDeep} from 'lodash/array'

export default class AccordiTab extends Component {

  // componentDidMount() {
  //     if(this.state.activeItems){
  //         this.state.activeItems.forEach((index) => {
  //             if (this.refs[`item-${ index }`]) {
  //                 this.refs[`item-${ index }`].allowOverflow();
  //             }
  //         });
  //     }
  //     // allow overflow for absolute positioned elements inside
  //     // the item body, but only after animation is complete
  //     ReactDOM.findDOMNode(this).addEventListener('transitionend', () => {
  //         this.state.activeItems.forEach((index) => {
  //             if (this.refs[`item-${ index }`]) {
  //                 this.refs[`item-${ index }`].allowOverflow();
  //             }
  //         });
  //     });
  // }

  // renderItems() {
  //   if (!this.props.children) {
  //     return null;
  //   }
  //   return flattenDeep(this.props.children)
  //     .map((item, index) => {
  //     const props = {
  //       key: index,
  //       ref: `item-${ index }`
  //     }
  //     return React.cloneElement(item, props);
  //   });
  // }

  render() {
    //return the appropriate class
    const formatClass = this.props.tabs
      ? "c-accorditabs--format-tabs"
      : "c-accorditabs--format-accordian";

    return (
      <div className={className('c-accorditabs', this.props.className, formatClass)}
        role="tablist"
        style={this.props.style}>
        {this.props.children}
      </div>
    )
  }
}

AccordiTab.defaultProps = {
    // activeItems: [0],
    allowMultiple: false,
    tabs: false
};

AccordiTab.propTypes = {
    tabs: PropTypes.bool,
    allowMultiple: PropTypes.bool,
    // activeItems: PropTypes.oneOfType([
    //     PropTypes.number,
    //     PropTypes.array,
    //     PropTypes.boolean
    // ]),
    className: PropTypes.string,
    style: PropTypes.object
};



// WEBPACK FOOTER //
// ./webapp/components/elements/AccordiTab/AccordiTab.js